// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { APPBaseElement } from './APPBaseElement';
import { ConfigGroup } from './ConfigGroup';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 系统配置项，全局统一配置，不能根据租户设置 实体类
 * 配置项
 */
export class ConfigItem extends APPBaseElement {
  /** 缺省值 : 缺省值 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 数据类型 : 数据类型 */
  private _dataType: EnumDataType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumDataType) {
    this._dataType = value;
  }

  /** 是否可空 : 是否可空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 配置组 的ID */
  private _configGroup_ID: string;

  /** 获取：配置组 的ID */
  public get configGroup_ID() {
    return this._configGroup_ID;
  }

  /** 设置：配置组 的ID */
  public set configGroup_ID(value: string) {
    this._configGroup_ID = value;
  }

  /** 配置组  */
  private _configGroup: ConfigGroup;

  /** 获取：配置组  */
  public get configGroup() {
    return this._configGroup;
  }

  /** 设置：配置组  */
  public set configGroup(value: ConfigGroup) {
    this._configGroup = value;
    if (value !== null) {
      this.configGroup_ID = value.id;
    } else {
      this.configGroup_ID = '';
    }
  }

  constructor() {
    super();
    this._defaultValue = '';
    this._dataType = EnumDataType.String;
    this._isNullable = true;
    this._configGroup_ID = '';
    this._configGroup = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ConfigItem, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.defaultValue = element.defaultValue;
      this.dataType = element.dataType;
      this.isNullable = element.isNullable;
      this.configGroup_ID = element.configGroup_ID;
      if (hasReference && element.configGroup !== null) {
        this.configGroup = element.configGroup;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.defaultValue = json.DefaultValue;
    this.dataType = json.DataType as EnumDataType;
    this.isNullable = json.IsNullable;
    this.configGroup_ID = json.ConfigGroup_ID;
    // if (json.ConfigGroup !== null) {
    //   this.configGroup = ConfigGroup.Create(json.ConfigGroup);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DefaultValue = this.defaultValue;
    json.DataType = this.dataType;
    json.IsNullable = this.isNullable;
    json.ConfigGroup_ID = this.configGroup_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'defaultValue', '缺省值', EnumDataType.String, this.defaultValue, true, '缺省值', '', '');
    context.addRow('基本属性', 'dataType', '数据类型', EnumDataType.Reference, this.dataType, true, '数据类型', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('基本属性', 'isNullable', '是否可空', EnumDataType.Bool, this.isNullable, true, '是否可空', '', '');
    return context;
  }

  static Create(json: any): ConfigItem {
    const configItem = new ConfigItem();
    configItem.Deserialize(json);
    configItem.json = json;
    return configItem;
  }
}
